import React from "react";
import "../../styles/components/marketplace-shared.css";

const PrimaryActionButton = ({
  type = "button",
  onClick,
  disabled = false,
  className = "",
  icon,
  spinning = false,
  variant = "primary",
  children,
}) => {
  const iconClass = icon
    ? `fa ${spinning ? `${icon} fa-spin` : icon}`
    : "";

  return (
    <button
      type={type}
      className={`marketplace-primary-cta marketplace-primary-cta--${variant} ${className}`.trim()}
      onClick={onClick}
      disabled={disabled}
    >
      {icon ? <i className={`${iconClass} m-r-10`}></i> : null}
      {children}
    </button>
  );
};

export default PrimaryActionButton;


